import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import authReducer from './authSlice.js';
import RequestCardsSlice from "./editeInformation.js"
import registerMarketerSlice from './registerMarketerSlice.js';
import addCustomerSlice from './addCustomerSlice.js';
import ThirdPartyInsuranceSlice from './thirdPartInsuranceStep.js'
import loanRequestReducer from './LoanWithoutDiamondsSlice.js';
import BusinessRegistrationSlice from './registerMarketslice.js'
import CustomerRevenuesSlice from './CustomerRevenuesSlice.js'
import ThirsPartyInsuranceDetail from "./thirsPartyInsuranceDetail.js"
const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['auth', 'register', 'charge'],
};

const persistedAuthReducer = persistReducer(persistConfig, authReducer);


export const store: any = configureStore({
    reducer: {
        auth: persistedAuthReducer,
        Cards: RequestCardsSlice,
        registerMarketer: registerMarketerSlice,
        addCustomer: addCustomerSlice,
        thirdPartyInsuranceSlice: ThirdPartyInsuranceSlice,
        loanRequest: loanRequestReducer,
        registerMarket: BusinessRegistrationSlice,
        CustomerRevenuesSlice,
        ThirsPartyInsuranceDetail: ThirsPartyInsuranceDetail,

    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
            },
        }),
});

export const persistor = persistStore(store);
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;